module.exports = __webpack_public_path__ + "static/24-32dfedd97b177765c5c4f2aec3d31ea3.jpg";